<div class="horizontal">
  @if (contactUrl()) {
    <a [href]="contactUrl()" [target]="'_blank'" class="link">
      <span class="text">{{ ('shared.components.publicFooter.contact' | translate).toUpperCase() }}</span>
    </a>
  }
  @if (legalNoticeUrl()) {
    <a [href]="legalNoticeUrl()" [target]="'_blank'" class="link">
      <span class="text">{{ ('shared.components.publicFooter.legalNotice' | translate).toUpperCase() }}</span>
    </a>
  }
  @if (dataProtectionUrl()) {
    <a [href]="dataProtectionUrl()" [target]="'_blank'" class="link">
      <span class="text">{{ ('shared.components.publicFooter.dataProtection' | translate).toUpperCase() }}</span>
    </a>
  }
  @if (websiteUrl()) {
    <a [href]="websiteUrl()" [target]="'_blank'" class="link">
      <span class="text">{{ ('shared.components.publicFooter.website' | translate).toUpperCase() }}</span>
    </a>
  }
</div>
